import { FC } from 'react'

import { ScreenSize } from '@/app/constants'
import { YandexMetrikaEvent } from '@/app/constants/metrics'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { CREATE_REQUEST_TYPE } from '@/components/entities/requests/model/constants'
import { AppButton } from '@/components/shared/button'
import { ButtonSizes } from '@/components/shared/button/ui/Button.types'
import { useYandexMetrika } from '@/components/shared/yandex-metrika/hooks/useYandexMetrika'
import { useRequestNavigation } from '@/components/widgets/request/hooks/useRequestNavigation'

type Props = {
  size?: ButtonSizes
}

const CreateRequestButton: FC<Props> = ({ size }) => {
  const { reachGoal } = useYandexMetrika()
  const { breakpoint } = useCurrentBreakpoint()
  const { navigateToCreateFormRequest } = useRequestNavigation()
  const isMobileScreen = [
    ScreenSize.Xxs,
    ScreenSize.Xs,
    ScreenSize.Sm
  ].includes(breakpoint)
  const isTabletScreen = [ScreenSize.Lg, ScreenSize.Md].includes(breakpoint)

  const handleRequestCreating = () => {
    navigateToCreateFormRequest()
    reachGoal(YandexMetrikaEvent.NEW_REQUEST_CREATE)
  }

  return (
    <AppButton
      type="button"
      variant="primary"
      size={size ?? (isMobileScreen || isTabletScreen ? 'small' : 'large')}
      data-testid="create-request-button-id"
      onClick={handleRequestCreating}
    >
      {CREATE_REQUEST_TYPE.name}
    </AppButton>
  )
}

export { CreateRequestButton }
